import React from 'react';
import styles from './DENTModalOverviewSurfaces.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import useSurfacesRows from './DENTModalOverviewSurfacesRows';
import { ToothSurface } from '../../../../graphql/graphql';
import { SurfaceInterface } from '../../Interfaces/Surface.interface';
import { SurfaceOperation } from '../../Enums/SurfaceOperation.enum';
import { SurfaceHandler } from '../../Interfaces/SurfaceHandler.interface';

interface Props {
	onSelectSurface: (
		surfaces: ToothSurface[],
		operation: SurfaceOperation,
	) => void;
	surfaces: SurfaceHandler;
}

const DENTModalOverviewSurfaces = ({ onSelectSurface, surfaces }: Props) => {
	const { t } = useTranslation();
	const { rows } = useSurfacesRows();

	const { showedSurfaces = [], selectedSurfaces = [] } = surfaces ?? {};

	const handleSurfaceClick = ({ type, closes, opens }: SurfaceInterface) => {
		const isActive = selectedSurfaces.includes(type);

		if (isActive) {
			onSelectSurface(closes, SurfaceOperation.REMOVE);
			return;
		}

		onSelectSurface(opens, SurfaceOperation.ADD);
	};

	const shouldShowSurfaces =
		'shouldShowSurfaces' in surfaces ? surfaces.shouldShowSurfaces : true;

	return (
		<div className={styles.container}>
			{rows.map((surfaceRow, index) => (
				<div className={styles.row} key={`row-${index}`}>
					{surfaceRow.map(surface => {
						if (!shouldShowSurfaces || !showedSurfaces.includes(surface.type)) {
							return (
								<span
									className={`${surface.className} ${styles.itemDisabled}`}
									key={surface.title}></span>
							);
						}

						return (
							<span
								className={`${surface.className} ${
									selectedSurfaces.includes(surface.type)
										? styles.itemSelected
										: ''
								}`}
								onClick={() => handleSurfaceClick(surface)}
								key={surface.type}>
								{t(surface.title)}
							</span>
						);
					})}
				</div>
			))}
		</div>
	);
};

export default DENTModalOverviewSurfaces;
